import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import assetsReducer from './store/assetsReducer';
import settingReducer from './store/settingReducer';
import authReducer from './store/authReducer';
import transactionReducer from './store/transactionReducer';
import counterpartyReducer from './store/counterpartyReducer';

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  assets: assetsReducer,
  setting: settingReducer,
  transaction: transactionReducer,
  countrypartys: counterpartyReducer,
});

// Persist config
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'assets', 'setting'], // choose which reducers you want to persist
};

// Wrap reducer with persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions in serializableCheck
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Persistor (needed for PersistGate)
export const persistor = persistStore(store);

// Infer types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
